/**
 * Returns a string of get quotes form url
 * @param formPath, value
 * @returns {*}
 */
export function getGetQuotesFormUrl(queryStr, formPath, value) {
  if (formPath === undefined || formPath === '') {
    return false;
  }

  if ((value === undefined || value === '') && (queryStr === undefined || queryStr === '')) {
    // both value and query string empty
    return `${formPath}`;
  } else if (value === undefined || value === '') {
    // has no value OR has value but no query string
    return `${formPath}${queryStr}`;
  } else if ((queryStr === undefined || queryStr === '') && value) {
    return `${formPath}?w=${value}`;
  }

  const newQueryParams = [];
  let locationQueryStr;
  let newQueryStr = '';
  // strip out state, suburb and gclid in query string
  const queryParts = queryStr.split('?');
  const paramsArr = queryParts[1].split('&');
  let i = paramsArr.length;
  // TODO: FIX BELOW PLEASE
  while (i--) { // eslint-disable-line no-plusplus
    if (paramsArr[i].includes('state') || paramsArr[i].includes('suburb') || paramsArr[i].includes('gclid')) {
      continue; // eslint-disable-line no-continue
    }
    newQueryParams.push(paramsArr[i]);
  }
  newQueryStr = `?${newQueryParams.join('&')}`;
  if (newQueryStr.length > 0 && value) {
    locationQueryStr = `${newQueryStr}&w=${value}`;
  } else if (newQueryStr.length > 0) {
    locationQueryStr = `${newQueryStr}`;
  } else if (value) {
    locationQueryStr = `?w=${value}`;
  }
  return `${formPath}${locationQueryStr}`;
}



// WEBPACK FOOTER //
// ./get-quotes/scripts/utils/url.js